import api from 'api/apiClient';
import { parseHoursMinutes, resolveIsoWeek } from 'modules/shared/utils';
import { API_DEPARTMENT_KEYS } from '../constants';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export const getEmployeeSchedules = async () => {
  const { data: raw } = await unwrap(await api.get('/api/analyst/employees/assignment'));

  return raw.map((e) => ({
    id: e.employee_id,
    name: e.name,
    department: API_DEPARTMENT_KEYS[e.department],
    siteVisitDetails: e.site_visit_details,
    taskDetails: e.drawing_or_design_details,
  }));
};

export const getEmployeeWeekSchedule = async (employeeId) => {
  if (!employeeId) {
    return { error: 'Employee ID is required' };
  }

  const { data: raw } = await unwrap(await api.get(`/api/analyst/employee/${employeeId}/schedule`));

  const now = new Date();
  const map = new Map();

  for (const assignment of raw) {
    const { week, year } = resolveIsoWeek(assignment.assigned_week, now);

    const key = `${year}-${week}`;
    const hours = parseHoursMinutes(assignment.alloted_time);

    map.set(key, (map.get(key) ?? 0) + hours);
  }

  return Array.from(map.entries()).map(([key, hours]) => {
    const [year, week] = key.split('-').map(Number);
    return { year, week, hours };
  });
};

export const assignTaskToEmployee = async (projectId, data) => {
  if (!projectId || !data) throw new Error('Project ID and data are required');

  await api.post(`/api/analyst/job/${projectId}/assign`, data);
};

export const editTaskAssignment = async (taskId, data) => {
  if (!taskId || !data) throw new Error('Task ID and data are required');

  await api.put(`/api/analyst/task/${taskId}/edit`, data);
};

export const deleteTaskAssignment = async (taskId) => {
  if (!taskId) throw new Error('Task ID is required');

  await api.delete(`/api/analyst/task/${taskId}/delete`);
};
